import * as React from "react";
import * as ReactDOM from "react-dom";
if (typeof UNION_INTERNAL_MODULE_SYSTEM !== 'undefined') {
  /* eslint-disable no-undef */
  UNION_INTERNAL_MODULE_SYSTEM.define('react', function () {
    return React;
  });
  UNION_INTERNAL_MODULE_SYSTEM.define('react-dom', function () {
    return ReactDOM;
  });
}
export { default } from "./components/FooterNavPagelet/index.js";